import { render, staticRenderFns } from "./mapping.vue?vue&type=template&id=616ebe66"
import script from "./mapping.vue?vue&type=script&lang=js"
export * from "./mapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports